'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'barcode-read';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f464';
var svgPathData = 'M0 64C0 28.7 28.7 0 64 0l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 32C46.3 32 32 46.3 32 64l0 80c0 8.8-7.2 16-16 16S0 152.8 0 144L0 64zm112 64c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm224 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zM240 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zM448 0c35.3 0 64 28.7 64 64l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-17.7-14.3-32-32-32l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0zM0 448l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 17.7 14.3 32 32 32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-35.3 0-64-28.7-64-64zm448 64l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c17.7 0 32-14.3 32-32l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 35.3-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBarcodeRead = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;